import req from './index';                 //连接接口文件
export const GETTREEDATA=function(e){   
   return req('get','/api',{data:e})    //post方法以及传参    qwe是字段   e是参数
}